import { Helmet } from "react-helmet-async";
import { SITE, isPlaceholder } from "@/config/site";

const resolveUrl = (path = "/") => {
  const base = !isPlaceholder(SITE.url)
    ? SITE.url.replace(/\/$/, "")
    : typeof window !== "undefined"
      ? window.location.origin
      : "";
  return `${base}${path}`;
};

export const SEO = ({ title, description, path = "/", image, jsonLd }) => {
  const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} | ${SITE.tagline}`;
  const desc = description || SITE.description;
  const url = resolveUrl(path);
  const ogImage = image || SITE.defaultOgImage;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {!isPlaceholder(SITE.googleSiteVerification) && (
        <meta name="google-site-verification" content={SITE.googleSiteVerification} />
      )}
      {!isPlaceholder(SITE.bingSiteVerification) && (
        <meta name="msvalidate.01" content={SITE.bingSiteVerification} />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
      {!isPlaceholder(SITE.twitterHandle) && <meta name="twitter:site" content={SITE.twitterHandle} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
